module.exports = __webpack_public_path__ + "static/img/bg.73e12059.jpg";